import {Component, OnInit, ViewChild} from '@angular/core';
import { MatSort} from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {CaexService} from 'src/app/services/caex.service';
import {TaxService} from 'src/app/services/tax.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {MemberService} from 'src/app/services/member.service';
import {FileService} from 'src/app/services/file.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-caex',
  templateUrl: './caex.component.html',
  styleUrls: [ './caex.component.scss' ]
})
export class CaexComponent implements OnInit {

  public searchForm: FormGroup;
  public matcher = new FormErrorStateMatcher();
  public spinner: boolean
  public memberExist: number = 0;

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'name' ];

  public dataSourceCaexMembers: MatTableDataSource<any>
  public displayedColumnsCaexMembers: string[] = [ 'name', 'cpf', 'category', 'hasOrder', 'edit', 'delete' ];

  public caexCategories: any[] = []
  public arrayOrders: any[] = []

  constructor (
    private _taxService: TaxService,
    public _caexService: CaexService,
    public _memberService: MemberService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _fileService: FileService,
  ) {

    this.searchForm = this._formBuilder.group({
      cpf: new FormControl('', [ Validators.required ])
    });

    this.getDolarCotation()
    this.loadCaexCategory()
    this.loadOrders()

  }


  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit () {

  }

  applyFilter (filterValue: string) {
    this.dataSourceCaexMembers.filter = filterValue.trim().toLowerCase();
  }

  getDolarCotation () {
    this._taxService.getById("4OC9uJyuX740nKeTDkOJ")
      .subscribe((result) => {
        this._caexService.dolarCotation = Number(result.data().value)
      })
  }

  selectedMember (member) {
    console.log("member: " + JSON.stringify(member))
    this._caexService.currentMember = member;
    this.router.navigate([ 'caex-member' ]);
  }

  gotoNewMember () {
    console.log("new member")
    this.router.navigate([ 'caex-new-member' ]);
  }

  loadOrders () {
    this._caexService.loadOrders()
      .subscribe((result) => {

        result.forEach((item: any) => {
          this.arrayOrders.push({
            "id": item.id,
            "member_id": item.data().member_id,
            "member_name": item.data().member_name
          })

        })
        this.loadAllMembers()
      });
  }

  loadAllMembers () {
    this.spinner = true

    this._caexService.loadAllMembers()
      .subscribe((result) => {

        let allMembers: any[] = []

        result.forEach((item) => {

          if (item.payload.doc.data().name && item.payload.doc.data().name != 'A DEFINIR' && item.payload.doc.data().name != 'Abecadail') {

            if (!item.payload.doc.data().deleted) {
              
              const cat_id = item.payload.doc.data().subCategory ? item.payload.doc.data().subCategory.id : ''
              let catExist = this.caexCategories.find((e) => {
                return e.id == cat_id
              })

              if (catExist) {

                let hasOrder = this.arrayOrders.find((e) => {
                  return e.member_id == item.payload.doc.id
                })

                allMembers.push({
                  'id': item.payload.doc.id,
                  'name': item.payload.doc.data().name,
                  'email': item.payload.doc.data().email,
                  'cellPhone': item.payload.doc.data().cellPhone,
                  'cpf': item.payload.doc.data().cpf,
                  'crm': item.payload.doc.data().crm,
                  'situation': item.payload.doc.data().situation,
                  'balance': item.payload.doc.data().balance,
                  'subCategory': item.payload.doc.data().subCategory,
                  'category': item.payload.doc.data().subCategory.name,
                  'hasOrder': hasOrder ? true : false
                })
              }
            }
          }

        })

        this.spinner = false;
        this.dataSourceCaexMembers = new MatTableDataSource(allMembers);
        this.dataSourceCaexMembers.sort = this.sort

      })
  }

  /*
  _getUserSubscription () {

    this._caexService.getUserSubscription('02450725008')//76984771005
      .subscribe((result) => {

        console.log("status: " + result.subscription.status)

        if (result.subscription.status == "ok") {
          console.log("-------------------------")

          result.subscription.lines.forEach((line) => {
            console.log(line)
          })

          console.log("---------------------")

          console.log(JSON.stringify(result.subscription))

        } else {
          console.log("ERRO >>>>>>>>>>>>")
        }

      })
  }
  */

  async loadCaexCategory () {
    this._caexService.selectSubcategoriesCaex()
      .subscribe(async (result) => {
        result.forEach(async (item) => {

          this.caexCategories.push({
            'id': item.payload.doc.id,
            'name': item.payload.doc.data().name,
            'documents': item.payload.doc.data().documents,
            'documents_en': item.payload.doc.data().documents_en,
            'hidden': item.payload.doc.data().hidden,
            'partner': item.payload.doc.data().partner
          })

        })

      })

  }

  exportToCSV () {

    let data: any[];

    let csvFile: any[] = []

    data = this.dataSourceCaexMembers.data;
    csvFile.push("" + ";" + 'Incrições CAEX' + '\r\n')

    let csvHeader: string;


    csvHeader = "" + ";"
    csvHeader += 'Nome' + ';'
    csvHeader += 'Doc' + ';'
    csvHeader += 'Empresa' + ';'
    csvHeader += 'Inscrito' + '\r\n'

    csvFile.push(csvHeader)

    data.forEach((item) => {

      let csvLine: string;
      csvLine = "" + ";"

      csvLine += (item.name || '') + ";";
      csvLine += (item.cpf || '') + ";";
      csvLine += (item.category || '-') + ";";
      csvLine += (item.hasOrder ? 'Sim' : 'Não') + "\r\n";

      csvFile.push(csvLine)

    })

    var BOM = "\ufeff";
    let csvData = BOM + csvFile;

    var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});

    this._fileService.saveFile(blob, "inscritos_CAEX.csv")

  }


  delete (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir este expositor?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._memberService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete room error: " + error.message)}
          )
      }
    })
  }


}

